import { useLayoutEffect, useRef } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { authStore } from '@/store/authStore';
import PreQuestionnaire from '@/pages/funnel/questionnaires/PreQuestionnaire';

interface ProtectedRoutesProps {
  type?: 'public' | 'protected';
}

const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ type = 'protected' }) => {
  const { accessToken } = authStore();
  const location = useLocation();
  const hasUpdatedPath = useRef(false);
  const currentPath = localStorage.getItem('currentPath') || '';

  const fullPath = `${location.pathname}${location.search}`;
  const isLockedToPreQuestionnaire = currentPath.includes('pre_questionnaire');
  const isCurrentlyOnPreQuestionnaire = location.pathname.includes('pre_questionnaire');

  useLayoutEffect(() => {
    if (
      !hasUpdatedPath.current &&
      accessToken &&
      type !== 'public' &&
      !isLockedToPreQuestionnaire
    ) {
      const prevStored = localStorage.getItem('currentPath');
      if (prevStored) {
        localStorage.setItem('prevPath', prevStored);
      }
      localStorage.setItem('currentPath', fullPath);
      hasUpdatedPath.current = true;
    }
  }, [accessToken, isLockedToPreQuestionnaire, type, fullPath]);

  if (isLockedToPreQuestionnaire && !isCurrentlyOnPreQuestionnaire) {
    return <Navigate to={currentPath} replace />;
  }

  if (isLockedToPreQuestionnaire) {
    return <PreQuestionnaire />;
  }

  if (type === 'public') {
    return !accessToken || currentPath === 'bufo' ? (
      <Outlet />
    ) : (
      <Navigate to={currentPath} replace />
    );
  }

  return accessToken ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoutes;
